module.exports = __webpack_public_path__ + "img/template_2.d37ee9e5.png";